/*@ngInject*/
const FormSummaryButtonPositionDirective = function ($document, $window, $timeout, coreConstant) {
    let linkFunction = function ($scope, $elm) {

        let timeoutList = [],
            element = $($elm),
            window = $($window),
            screen = $($document),
            navigationToggleButton = $('.navigationContainer'),
            formViewer = $('.formViewer').first();

        function positionContainer(container) {
            let parentElementWidth = element.width(),
                parentElementXOffset = element.offset().left,
                screenWidth = screen.width(),
                isOffScreen = (parentElementWidth + parentElementXOffset) > screenWidth,
                totalWidthOffscreen,
                offset = 20,
                newXPosition;

            if (isOffScreen) {
                totalWidthOffscreen = (parentElementXOffset + parentElementWidth) - screenWidth;
                newXPosition = parseInt(totalWidthOffscreen + offset);
                container.css('right', newXPosition);
            }
            else {
                container.css('right', 10);
            }
        }

        function updateScreen() {
            let actionButtonContainer = element.find('.actionButtonContainer'),
                deleteButtonContainer = element.find('.deleteButtonContainer');

            if (actionButtonContainer.length) {
                positionContainer(actionButtonContainer);
            }

            if (deleteButtonContainer.length) {
                positionContainer(deleteButtonContainer);
            }
        }

        $scope.$watch('$ctrl.isDeleting', function () {
            timeoutList.push($timeout(function () {
                updateScreen();
            }, 400));
        });

        window.on('resize.formSummaryButtonPosition', updateScreen);
        formViewer.on('scroll', updateScreen);
        $scope.$on(coreConstant.NAVIGATION_DRAWER_TOGGLED, updateScreen);

        $scope.$on('$destroy', function () {
            window.off('resize.formSummaryButtonPosition', updateScreen);
            formViewer.off('scroll', updateScreen);

            _.each(timeoutList, function (item) {
                $timeout.cancel(item);
            });
        });

        timeoutList.push($timeout(function () {
            updateScreen();
        }, 400));
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umFormViewer')
    .directive('formSummaryButtonPosition', FormSummaryButtonPositionDirective);
